import { getEnvVar } from './getEnvVar'

export function isStagingEnv() {
  return getEnvVar('ENV') === 'staging'
}
